import React, { useState } from "react";
import { useAppSelector } from "@/redux-config/hooks";
import { selectUser } from "@/redux-config/entities/user";
import { Helmet } from "react-helmet";
import { CustomBreadCrumb } from "@/components/customBreadCrumb";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { CustomInput } from "@/components";
import { AdminApi } from "@/api";
import { useNavigate } from "react-router-dom";

export const AdminNew: React.FC<{}> = () => {
  const user = useAppSelector(selectUser);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const crumbs = [
    { name: t("Dashboard"), href: "/" },
    { name: t("Admin"), href: "#" },
    { name: t("New"), href: "#" }
  ];

  const phoneNumberRegex = /^(09\d{9})$/;

  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const [loading, setLoading] = useState<boolean>(false);

  const handleCreateAdmin = () => {
    setLoading(true);
    AdminApi.CreateAdmin(user, phone, password, firstName, lastName).then((data) => {
      navigate(`/admin/info/${data.data.id}`);
      setLoading(false);
    }).catch((err) => {
      setLoading(false);
    });
  };

  return (
    <>
      <Helmet>
        <title>MahdiBookShop | User List</title>
        <meta name="description" content="Basic example" />
      </Helmet>
      <div className="d-flex flex-column">
        <CustomBreadCrumb breadCrumbList={crumbs} />
        <div className={"d-flex flex-row flex-wrap"}>
          <div className={"col-12 col-md-6 col-lg-4 p-2"}>
            <div
              className={
                "d-flex flex-column bg-custom-white p-3 rounded-3  gap-2 h-100"
              }
            >
              <h5>{t("BasicInfo")}</h5>
              <label className={"d-flex flex-column"}>
                <small>{t("FirstName")}</small>
                <CustomInput
                  name={"FirstName"}
                  type={"text_number"}
                  className={`custom-input ${
                    firstName.length == 0
                      ? "border-reg"
                      : firstName.length > 2
                        ? "border-success"
                        : "border-error"
                  }`}
                  value={firstName}
                  onChange={setFirstName}
                />
              </label>
              <label className={"d-flex flex-column"}>
                <small>{t("LastName")}</small>
                <CustomInput
                  name={"LastName"}
                  type={"text_number"}
                  className={`custom-input ${
                    lastName.length == 0
                      ? "border-reg"
                      : lastName.length > 2
                        ? "border-success"
                        : "border-error"
                  }`}
                  value={lastName}
                  onChange={setLastName}
                />
              </label>
              <label className={"d-flex flex-column"}>
                <small>{t("Phone")}</small>
                <CustomInput
                  name={"phone"}
                  type={"number"}
                  className={`custom-input ${
                    phone.length == 0
                      ? "border-reg"
                      : phoneNumberRegex.test(phone)
                        ? "border-success"
                        : "border-error"
                  }`}
                  value={phone}
                  onChange={setPhone}
                />
              </label>

              <label className={"d-flex flex-column"}>
                <small>{t("password")}</small>
                <CustomInput
                  name={"password"}
                  type={"password"}
                  className={`custom-input ${
                    password.length == 0
                      ? "border-reg"
                      : password.length >= 8
                        ? "border-success"
                        : "border-error"
                  }`}
                  value={password}
                  onChange={setPassword}
                />
              </label>
              <div>
                <button
                  className={"btn prm-btn rounded-5 px-4 mt-3"}
                  disabled={
                    !(
                      phoneNumberRegex.test(phone) &&
                      firstName.length > 2 &&
                      lastName.length > 2 &&
                      password.length >= 8
                    ) || loading
                  }
                  onClick={() => {
                    handleCreateAdmin();
                  }}
                >
                  {t("submit")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
